import React from "react";
import { CountStyle, TabButtonStyle } from "./styles";

interface DashboardTabProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  count: number;
  active?: boolean;
}

const DashboardTab = ({
  count,
  active,
  children,
  ...rest
}: DashboardTabProps) => {
  return (
    <TabButtonStyle {...rest} active={active}>
      {children}
      <CountStyle>&nbsp;{count}</CountStyle>
    </TabButtonStyle>
  );
};

export default DashboardTab;
